export default "__VITE_ASSET__HsuwZYHj__"